import React, { FC, useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faCheck } from '@fortawesome/free-solid-svg-icons';
import './DropDownList.css';

export interface DropDownListProps {
    current: string;
    list: string[];
    onChange: (value: string, index: number) => void;
};

const DropDownList: FC<DropDownListProps> = ({ current, list, onChange }) => {
    const ref = useRef(null);
    const [ isOpen , setIsOpen ] = useState(false);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if(ref.current && !(ref.current as any).contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    const onClick = (item: string, index: number) => {
        setIsOpen(false);
        if(item === current) return;
        onChange(item, index);
    };

    return (
        <div className='DropDownList'>
            <div onClick={() => setIsOpen(true)}>
                <span>{current}</span>
                <span><Icon icon={faChevronDown}/></span>
            </div>

            {isOpen &&
            <ul ref={ref}>
                {list.map((item, index) => (
                <li
                    key={index}
                    className={item === current ? 'current' : undefined}
                    onClick={() => onClick(item, index)}
                >
                    <span>{item}</span>
                    {item === current ? <span><Icon icon={faCheck}/></span> : <span/>}
                </li>))}
            </ul>}
        </div>
	);
};

export default DropDownList;
